import React from 'react';

//Estilos
import './Manager.css';

function Manager({ states, functions }) {
    const { password, viniedos, selectedVineyards } = states;
    const {
        register,
        watch,
        handleSubmit,
        formState: { errors },
        onSubmit,
        buildBooleanOptions,
        checkAllVineyards,
        addSelectedVineyards,
        isEqualArray,
    } = functions;

    return (
        <div className="manager-container">
            <h4 className="profile-title">Datos del Encargado</h4>
            <form className="manager-form" onSubmit={handleSubmit(onSubmit)}>
                <label className="label-signup">
                    <div>
                        <span>Usuario: </span>
                        <input
                            className="signup-input"
                            type="text"
                            {...register('usuario', {
                                required: 'Debe ingresar un nombre de usuario',
                            })}
                            onKeyPress={(e) => {
                                if (e.target.value.length > 20) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </div>
                    {errors.usuario && (
                        <small className="form__error">
                            {errors.usuario?.message}
                        </small>
                    )}
                </label>
                <label className="label-signup">
                    <div>
                        <span>Nombre: </span>
                        <input
                            className="signup-input"
                            type="text"
                            {...register('nombre', {
                                required: 'Debe ingresar un nombre',
                            })}
                            onKeyPress={(e) => {
                                if (e.target.value.length > 20) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </div>
                    {errors.nombre && (
                        <small className="form__error">
                            {errors.nombre?.message}
                        </small>
                    )}
                </label>
                <label className="label-signup">
                    <div>
                        <span>Apellido: </span>
                        <input
                            className="signup-input"
                            type="text"
                            {...register('apellido', {
                                required: 'Debe ingresar un apellido',
                            })}
                            onKeyPress={(e) => {
                                if (e.target.value.length > 20) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </div>
                    {errors.apellido && (
                        <small className="form__error">
                            {errors.apellido?.message}
                        </small>
                    )}
                </label>
                <label className="label-signup">
                    <div>
                        <span>Celular: </span>
                        <input
                            className="signup-input"
                            type="text"
                            {...register('celular', {
                                required: 'Debe ingresar un celular',
                            })}
                            onKeyPress={(e) => {
                                if (e.target.value.length > 20) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </div>
                    {errors.celular && (
                        <small className="form__error">
                            {errors.celular?.message}
                        </small>
                    )}
                </label>
                <label className="label-signup">
                    <div>
                        <span>Correo: </span>
                        <input
                            className="signup-input"
                            type="email"
                            {...register('correo', {
                                required: 'Debe ingresar un correo',
                            })}
                            onKeyPress={(e) => {
                                if (e.target.value.length > 25) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </div>
                    {errors.correo && (
                        <small className="form__error">
                            {errors.correo?.message}
                        </small>
                    )}
                </label>
                <label className="label-signup">
                    <div>
                        <span>Clave: </span>
                        <input
                            className="signup-input"
                            type="password"
                            autoComplete="off"
                            {...register('clave', {
                                minLength: {
                                    value: 8,
                                    message:
                                        'La clave debe tener un mínimo de 8 caracteres',
                                },
                                pattern: {
                                    value: /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&-])[A-Za-z\d@$!%*?&#-]/,
                                    message:
                                        'La clave debe tener al menos una minúscula, una mayúscula, un número y un caracter especial [@$-!%*?&#]',
                                },
                            })}
                            onKeyPress={(e) => {
                                if (e.target.value.length > 20) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </div>
                    {errors.clave && (
                        <small className="form__error">
                            {errors.clave?.message}
                        </small>
                    )}
                </label>
                <label className="label-signup">
                    <div>
                        <span>Confirmar clave: </span>
                        <input
                            className="signup-input"
                            type="password"
                            autoComplete="off"
                            {...register('confirmPassword', {
                                validate: (value) =>
                                    value === password.current ||
                                    'Las claves no coinciden',
                            })}
                            onKeyPress={(e) => {
                                if (e.target.value.length > 20) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </div>
                    {errors.confirmPassword && (
                        <small className="form__error">
                            {errors.confirmPassword?.message}
                        </small>
                    )}
                </label>
                <label className="label-signup">
                    <div>
                        <span>Correo Confirmado: </span>
                        <select
                            className="signup-input"
                            disabled
                            {...register('confirmado', {})}
                        >
                            {buildBooleanOptions()?.map((op) => {
                                return (
                                    <option key={op.name} value={op.value}>
                                        {op.title}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                    {errors.confirmado && (
                        <small className="form__error">
                            {errors.confirmado?.message}
                        </small>
                    )}
                </label>
                <label className="label-signup">
                    <div>
                        <span>Habilitado: </span>
                        <select {...register('habilitado')}>
                            <option value={2}>SI</option>
                            <option value={1}>NO</option>
                        </select>
                    </div>
                    {errors.habilitado && (
                        <small className="form__error">
                            {errors.habilitado?.message}
                        </small>
                    )}
                </label>
                <section className="manager-section">
                    <div>
                        <input
                            {...register('checkAll')}
                            type="checkbox"
                            checked={isEqualArray(
                                viniedos.map((v) => {
                                    return v.num;
                                }),
                                selectedVineyards
                            )}
                            value={false}
                            onChange={() => checkAllVineyards()}
                        />
                        <span>Mis Viñedos: </span>
                        <div className="manager-vineyard-container">
                            {viniedos?.map((v, i) => {
                                return (
                                    <label key={i}>
                                        <input
                                            type="checkbox"
                                            value={v.num}
                                            checked={selectedVineyards.includes(
                                                v.num
                                            )}
                                            onChange={(e) =>
                                                addSelectedVineyards(e)
                                            }
                                        />
                                        {v.num}
                                    </label>
                                );
                            })}
                        </div>
                    </div>
                    <div>
                        <span>Viñedos Asignados al Encargado: </span>
                        <div>
                            {selectedVineyards?.map((v, i) => {
                                return <p key={i}>{v}</p>;
                            })}
                        </div>
                    </div>
                </section>
                <div className="managers_list-form-footer">
                    <button className="btn btn-primary" type="submit">
                        Guardar
                    </button>
                </div>
            </form>
        </div>
    );
}

export default Manager;
